import React, {useEffect, useRef} from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import SelectGroupTable from "./SelectGroupTable";
import {getActualProgramGroups} from "../../../../../../ManageOOP/Resources/OpMod/MyOPMod/store/actions";
import {getDictGroupTypes} from "../../../../../../Dict/store/actions";
import Grid from "@material-ui/core/Grid";
import DataSelect from "../../../../../../ui/DataSelect";
import {Typography} from "@material-ui/core";
import TextField from "../../../../../../ui/TextField";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  dialog: {
    width: "620px"
  }
});

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const initialData = {
  groupId: null,
  newGroupCode: "",
  newGroupType: null,
  newGroupStartDate: null,
  newGroupEndDate: null,
  newGroupCapacity: 0
}

const SelectGroupModal = ({
                           requestId,
                           groupId,
                            programId,
                           open,
                           handleClose,
                           handleAccept,
                            getActualProgramGroups,
                            actualGroups,
                            getDictGroupTypes, groupTypeList,
                           classes
                         }) => {
  const [data, setData] = React.useState(initialData);
  const prevData = usePrevious(data);

  useEffect(() => {
    if (programId && programId > -1){
      getActualProgramGroups(programId);
    }
  }, [programId]);

  useEffect(() => {
    if (actualGroups && actualGroups.length < 1) {
      getDictGroupTypes();
    }
  },[actualGroups]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
  };

  const onConfirm = () => {
    if (data) {
      if (data.groupId && data.groupId > 0) {
        handleAccept(requestId, data.groupId, null)
      } else {
        const newGroupData = {
          code: data.newGroupCode,
          capacity: data.newGroupCapacity,
          groupType: data.newGroupType,
          startDate: data.newGroupStartDate,
          endDate: data.newGroupEndDate
        };
        handleAccept(requestId, null, newGroupData);
      }
    }
    onClose();
  };

  const onClose = () => {
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Выбор группы обучения</DialogTitle>
        <DialogContent>
          {actualGroups && actualGroups.length > 0 ?
              <DataSelect
                value={data.groupId}
                dataSource={actualGroups}
                onChange={value => onChange("groupId", value.id)}
                getOptionLabel={option => option.code}
                keyField="id"
                label="Учебная группа"
              />:
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography style={{margin: "16px 0 8px 0"}} color={"textSecondary"}>
                  Отсутствуют группы для выбора. Необходимо создать новую группу
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  value={data.newGroupCode || ""}
                  onChange={e => onChange("newGroupCode", e.target.value)}
                  label="Код группы"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  value={data.newGroupCapacity || ""}
                  onChange={e => onChange("newGroupCapacity", e.target.value)}
                  label="Макс. кол-во"
                />
              </Grid>
              <Grid item xs={6}>
                {groupTypeList && <DataSelect
                  value={data.newGroupType}
                  onChange={value => onChange("newGroupType", value._key)}
                  label="Тип группы"
                  dataSource={groupTypeList}
                  keyField="_key"/>}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={data.newGroupStartDate || ''}
                  onChange={e => onChange("newGroupStartDate", e.target.value)}
                  label="Начало обучения"
                  format="dd.MM.yyyy"
                  type="date"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={data.newGroupEndDate || ''}
                  onChange={e => onChange("newGroupEndDate", e.target.value)}
                  label="Окончание обучения"
                  format="dd.MM.yyyy"
                  type="date"
                />
              </Grid>
            </Grid>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            onClick={() => onConfirm()}
            color="green"
            disabled={!data.groupId && (!data.newGroupCode || !data.newGroupCapacity || !data.newGroupStartDate )}
          >
            Подтвердить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )};

const mapStateToProps = state => ({
  actualGroups: state.programs.actualGroups,
  groupTypeList: state.dictAll.groupTypeList
});

const mapDispatchToProps = dispatch => ({
  getActualProgramGroups: (programId) => dispatch(getActualProgramGroups(programId)),
  getDictGroupTypes: () => dispatch(getDictGroupTypes())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectGroupModal));
